import {
  TableCell as MuiTableCell,
  SxProps,
  Theme,
  styled,
} from '@mui/material';
import { ReactNode } from 'react';

export interface ColumnDef<R, C> {
  readonly header: (context: C) => string;
  readonly render: (row: R, context: C) => ReactNode;
  readonly padding?: 'inline' | 'none';
  readonly colSpan?: number;
  readonly minWidth?: number;
  readonly sx?: SxProps<Theme>;
  readonly sort?: {
    sortState: number | undefined;
    sortFn: (context: C) => void;
  };
}

interface ColumnCellProps<R, C> {
  columnDef: ColumnDef<R, C>;
  row: R;
  context: C;
  sx?: SxProps<Theme>;
}

export function ColumnCell<R, C>({
  columnDef,
  row,
  context,
  sx,
}: ColumnCellProps<R, C>) {
  return (
    <TableCell
      sx={sx}
      $padding={columnDef.padding}
      $minWidth={columnDef.minWidth}
      colSpan={columnDef.colSpan}
    >
      {columnDef.render(row, context)}
    </TableCell>
  );
}

interface TableCellProps {
  $padding?: 'inline' | 'none';
  $minWidth?: number;
}

const TableCell = styled(MuiTableCell)<TableCellProps>(
  ({ $padding, $minWidth }) => ({
    ...($padding === 'inline' && {
      padding: '0 16px',
    }),
    ...($padding === 'none' && {
      padding: '0 0 0 4px',
    }),
    minWidth: $minWidth,
  }),
);
